import { getMetaContent } from "../../../Common/helpers/meta";

export class SignInError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "SignInError";
    this.status = status;
  }
}

const parseErrorMessage = (responseText) => {
  try {
    const { error, errors } = JSON.parse(responseText);
    if (error) return error;
    if (errors) return Object.values(errors).flat().join(" ");
  } catch (e) {
    // fall through
  }
  return "There was a problem signing in. Please try again.";
};

export const signIn = async ({ email, password, rememberMe }) => {
  const response = await fetch("/users/sign_in", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": getMetaContent("csrf-token"),
    },
    body: JSON.stringify({
      user: {
        email,
        password,
        remember_me: rememberMe ? 1 : 0,
      },
    }),
  });

  if (!response.ok) {
    const redirectPath = response.headers.get("X-Redirect-Path");
    if (redirectPath) {
      window.location.href = redirectPath;
      return null;
    }
    const text = await response.text();
    throw new SignInError(parseErrorMessage(text), response.status);
  }

  return response.json();
};

export const redirectTo = (url) => {
  window.location.replace(url);
};
